import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    iconCircle: {
      width: '16px',
      height: '16px',
      aspectRatio: '1/1',
      borderRadius: '50%',
      border: '1px solid #A0A3A4',
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#6E6E6D',
      fontFamily: '"General Grotesque"',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '125.705%',
      cursor: 'pointer',
      flexShrink: 0,
    },
    tooltipContent: {
      maxWidth: '320px',
      minHeight: '49px',
      borderRadius: '16px',
      background: '#FFF',
      boxShadow: '0 4px 4px 0 rgba(194, 194, 194, 0.25)',
      padding: '6px',
      position: 'relative',
      paddingLeft: '35px',
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      pointerEvents: 'auto',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'calc(100vw - 48px)',
        minHeight: 'auto',
        padding: '12px',
        paddingLeft: '36px',
      },
    },
    tooltipIcon: {
      position: 'absolute',
      left: '10px',
      top: '10px',
      width: '16px',
      height: '16px',
      aspectRatio: '1/1',
      borderRadius: '50%',
      border: '1px solid #313131',
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#313131',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '125.705%',
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        left: '10px',
        top: '10px',
      },
    },
    tooltipText: {
      color: '#313131',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
    },
  }),
  { name: 'InfoTooltip' },
);

export default useStyles;
